import styled from "styled-components";
import { responsive } from "Styles/Constants";
import { COLORS } from "Styles/Constants";


//IMAGES
import { ReactComponent as InstaIcon } from "../../Assets/Images/Header/Instagram.svg";
import PageHeadingTop from "../../Assets/Images/PageHeading/breadcrumb_top.svg";
import PageHeadingMobile from "../../Assets/Images/PageHeading/vecotor_top_mobile.svg";
import PageHeadingBottom from "../../Assets/Images/PageHeading/breadcrumb_bottom.svg";



export const PageHeadingContainer = styled.div`
   font-family: 'Outfit', sans-serif;

    .pageheading_section{
        background: #FFF9EB; 
        padding: 50px 0;
        position: relative;
        &:before {
            content: "";
            position: absolute;
            top: 0;
            right: 0;
            width: 100%;
            height: 100%;
            background: url(${PageHeadingTop}) no-repeat;
            background-size: contain;
            background-position: top right;
        }

        &:after {
            content: "";
            position: absolute;
            bottom: 0;
            right: 0;
            width: 100%;
            height: 100%;
            background: url(${PageHeadingBottom}) no-repeat;
            background-size: contain;
            background-position: left bottom;
        }
        .mygrid-container{
            position:relative;
            z-index:1;
        }
    }
    /* tone="site" text: same title style as the Home and About heroes, blue instead of red */
    .pageheading_section--site {
        .page_heading_h1 {
            margin: 0;
            color: #142a6e;
            font-family: "Outfit", sans-serif;
            font-size: 52px;
            font-weight: 800;
            line-height: 1.08;
            letter-spacing: -0.5px;

            @media (max-width: 599px) {
                font-size: 38px;
            }
        }

        .page_heading_h1 .redfont,
        .page_heading_h1 .sm_accent {
            color: #1f63e0;
        }

        nav.breadcrumb_page_heading {
            margin-bottom: 10px;
            font-size: 15px;
            font-weight: 500;
        }

        nav.breadcrumb_page_heading span {
            color: #1f63e0;
        }

        nav.breadcrumb_page_heading a {
            color: #414b6b;

            &:hover {
                color: #142a6e;
            }
        }
    }

    /* tone="site": same light tint as the Home and About heroes; the original shapes are kept but
       drawn in the site blue (each SVG is used as a mask, so its own 10% opacity carries over) */
    .pageheading_section--site {
        background: #f7f9ff;

        &:before,
        &:after {
            background: #1f63e0;
            -webkit-mask-repeat: no-repeat;
            mask-repeat: no-repeat;
            -webkit-mask-size: contain;
            mask-size: contain;
        }

        &:before {
            -webkit-mask-image: url(${PageHeadingTop});
            mask-image: url(${PageHeadingTop});
            -webkit-mask-position: top right;
            mask-position: top right;
        }

        &:after {
            -webkit-mask-image: url(${PageHeadingBottom});
            mask-image: url(${PageHeadingBottom});
            -webkit-mask-position: left bottom;
            mask-position: left bottom;
        }
    }

    nav.breadcrumb_page_heading span{
        color: #EE2D2F;
    }
    nav.breadcrumb_page_heading a {
        text-decoration: none;
        color: #021E40;
    }

  }

@media (max-width: 991px) {
    .pageheading_section:after{
        background-size: 325px;
    }
    .pageheading_section:before{
        background-size: contain !important;
        background-position: right !important;
        background: url(${PageHeadingMobile}) no-repeat;
    }


}

@media (max-width: 767px) {
    .pageheading_section:after{
        background-size: 230px;
    }
    .pageheading_section:before{
        background-size: 250px;
        display: none;
    }
}


@media (max-width: 991px) {
    .pageheading_section--site:after {
        -webkit-mask-size: 325px;
        mask-size: 325px;
    }
    .pageheading_section--site:before {
        background: #1f63e0 !important;
        -webkit-mask-image: url(${PageHeadingMobile});
        mask-image: url(${PageHeadingMobile});
        -webkit-mask-position: right;
        mask-position: right;
    }
}

@media (max-width: 767px) {
    .pageheading_section--site:after {
        -webkit-mask-size: 230px;
        mask-size: 230px;
    }
}
`;
